export default __webpack_public_path__ + "static/media/no-results-dark.a132ee93.png";